module.exports = __webpack_public_path__ + "static/media/nav_rank_upfe64c9d6e23788c974ea4b4927c40209.webp";